module.exports = __webpack_public_path__ + "img/logo.0456d1b6.png";